// Webpack Imports
import 'bootstrap';


( function ( $ ) {
	'use strict';

	// JQuery fallback: add title attribute from placeholder
	$( 'input, textarea' ).attr( 'title', function () {
		return $( this ).attr( 'placeholder' );
	} );

	// Focus Search if Searchform is empty
	$( '.search-form' ).on( 'submit', function ( e ) {
		var search = $( '#s' );
		if ( search.val().length < 1 ) {
			e.preventDefault();
			search.focus();
		}
	} );

	//content game
	if($('.game__infos').find('.info__box--green').length == 2) {

		if($(window).width() >= 767.98) {
			$('.info__box--green:first').addClass('first');
			$('.info__box--green:last').addClass('second');
		} else {
			$('.info__box--green:first').addClass('first-m');
			$('.info__box--green:last').addClass('second-m');
		}
	}
	
}( jQuery ) );



  